<template>
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.RoleName") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="role.roleName"
                      :name="'roleName'"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                    />
                  </div>
                  <label class="error">{{ errors.first('roleName') }}</label>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.RoleType") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-3">
                  <div>
                    <select class="form-control" disabled v-model="role.roleType" name="roleType">
                      <option value="0">{{$t("message.Super Admin") }}</option>
                      <option value="1">{{$t("message.Platform") }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t("message.FunctionSelection") }}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                   <v-jstree :data="functionList" show-checkbox multiple allow-batch whole-row @item-click="itemClick"></v-jstree>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import VJstree from 'vue-jstree'

export default {
  mixins: [config.globalMixin],
  components: {
    VJstree 
  },
  data() {
    return {
      role: {},
      roleList:[],
      functionList:[],
      node:[]
    };
  },
  created() {
    this.init();
  },
  mounted() {
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.roleId = id;
        let data = await this.$store.dispatch("getSystemRoleDetail", this.setFormData(obj));
        this.$set(this, "role", data.data.result);
        this.node = data.data.result.systemFuncs;
        this.getRoleList();
      } else {
        let initUser = {
          id: null,
          roleType: "1",
          roleName: "",
        };
        this.node = [];
        this.$set(this, "role", initUser);
        this.getRoleList();
      }
    },
    async getRoleList(){
        let obj = this.getAuthObj;
        let data = await this.$store.dispatch("getSystemFuncAllList", this.setFormData(obj));
        for (var i = 0; i < data.data.result.length; i++) {
            data.data.result[i].selected = false
            for(var j = 0; j < this.node.length; j++){
                if(data.data.result[i].id==this.node[j]){
                    data.data.result[i].selected = true;
                }
            }
        }
        this.functionList = [];
        for(var i=0;i<data.data.result.length;i++){
          if(data.data.result[i].parentId == 0){
            this.functionList.push({
              "id": data.data.result[i].id,
              "text": data.data.result[i].funcName,
              "selected":data.data.result[i].selected,
              "opened": true,
              children: []
            })
          }
        }
        for (var i = 0; i < this.functionList.length; i++) {
            for (var j = 0; j < data.data.result.length; j++) {
                if (this.functionList[i].id == data.data.result[j].parentId) {
                    var node = {
                        "id": data.data.result[j].id,
                        "text": data.data.result[j].funcName,
                        "selected":data.data.result[j].selected,
                        "opened": true,
                        children: []
                    };
                    for (var k = 0; k < data.data.result.length; k++) {
                        if (data.data.result[k].parentId == data.data.result[j].id) {
                            node.children.push({
                                "id": data.data.result[k].id,
                                "text": data.data.result[k].funcName,
                                "selected":data.data.result[k].selected,
                                children: []
                            });
                        }
                    }
                    this.functionList[i].children.push(node);
                }
            }
        }
        this.$set(this, "roleList", data.data.result);
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                    that.$store.commit("setwarning", {
                      string: "",
                      boolean: false,
                    });
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for(var key in this.role){
          obj[key] = this.role[key];
        }
        var ids=[];
        for(var i=0;i<this.functionList.length;i++){
          if(this.functionList[i].selected){
            ids.push(this.functionList[i].id);
          }
          for(var j=0;j<this.functionList[i].children.length;j++){
            if(this.functionList[i].children[j].selected){
              ids.push(this.functionList[i].children[j].id);
            }
            for(var k=0;k<this.functionList[i].children[j].children.length;k++){
              if(this.functionList[i].children[j].children[k].selected){
                ids.push(this.functionList[i].children[j].children[k].id);
              }
            }
          }
        }
        obj.funcIds = ids.join(',')
        if(this.$route.query.id){
           var  data = await this.$store.dispatch("updateSystemRole", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createSystemRole", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.roleIds = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteSystemRole", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    itemClick (node) {
    }
  }
};
</script>
